import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';

export const getInboxCorrectionRequest = createAsyncThunk('inboxCorrection/getRequest', async (data) => {
    try {
        const response = await axios.post('/CorrectionInAttendance/get-request', data, {
            headers: { 'Content-Type': 'application/json' }
        });

        return response?.data;
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateInboxCorrectionRemarks = createAsyncThunk('inboxCorrection/updateRemarks', async (data) => {
    try {
        const response = await axios.put('/CorrectionInAttendance/request-status/' + data?.id, data?.data, {
            headers: { 'Content-Type': 'application/json' }
        });

        toast.success(response?.data?.message || 'Status updated successfully.');
        return response?.data;
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

const inboxCorrectionSlice = createSlice({
    name: 'inboxCorrection',
    initialState: {
        correction: []
    },
    reducers: {
        removeInboxCorrection: (state) => {
            state.correction = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getInboxCorrectionRequest.fulfilled, (state, action) => {
            state.correction = action?.payload;
        });
    }
});

export const { removeInboxCorrection } = inboxCorrectionSlice.actions;
export default inboxCorrectionSlice.reducer;
